import { ReactNode } from 'react'
import zeresLogo from '../assets/zeres-logo-full.png'
import evHero from '../assets/ev-hero.jpg'
import zeresLogoWhite from '@/assets/logo-dark.webp'
import { useTranslation } from 'react-i18next'

type Props = {
  title: string
  subtitle: string
  children: ReactNode
}

export default function AuthShell({ title, subtitle, children }: Props) {
  const { t } = useTranslation()
  return (
    <div className='ev-journey-scope bg-background min-h-screen'>
      <div className='flex min-h-screen flex-col lg:flex-row'>
        <div className='relative hidden overflow-hidden lg:flex lg:w-1/2'>
          <img
            src={evHero}
            alt='Elektrisch rijden met zonne-energie'
            className='absolute inset-0 h-full w-full object-cover'
          />
          <div className='from-foreground/70 via-foreground/20 absolute inset-0 bg-gradient-to-t to-transparent' />
          <div className='text-primary-foreground relative z-10 flex flex-col justify-end p-12'>
            <div className='mb-4'>
              <img
                src={zeresLogoWhite}
                alt='Zeres - Zero Emission Services'
                className='h-10 w-auto'
              />
            </div>
            <h2 className='mb-3 text-3xl leading-tight font-bold'>
              {t('Earn money with every charging session')}
            </h2>
            <p className='text-primary-foreground/80 max-w-md text-lg'>
              {t(
                'Receive a fee for every kWh charged through your charging point. Sustainable and profitable.'
              )}
            </p>
          </div>
        </div>

        <div className='flex flex-1 items-center justify-center p-6 sm:p-12'>
          <div className='w-full max-w-md'>
            <div className='mb-10'>
              <div className='mb-8 flex justify-center'>
                <img
                  src={zeresLogo}
                  alt='Zeres - Zero Emission Services'
                  className='h-16 w-auto'
                />
              </div>
              <h1 className='text-foreground mb-2 text-2xl font-bold'>
                {title}
              </h1>
              <p className='text-muted-foreground'>{subtitle}</p>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
